export * from './dynamic-component.directive';
export * from './module';
export * from './options';



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/~/ng-dynamic/src/dynamic-component/index.js
// module id = ../../../../ng-dynamic/src/dynamic-component/index.js
// module chunks = 3